<ng-container *ngIf="selectedSet.size | i18nPlural: buttonText | craftTerm: { count: selectedSet.size } as text">
  <button
    type="button"
    class="btn btn-menu"
    [disabled]="disabled"
    (menuOpened)="onMenuOpened()"
    (menuClosed)="onMenuClosed()"
    [matMenuTriggerFor]="multiSelectMenu"
    [matTooltip]="text"
  >
    <span class="ellipsis">
      {{ text }}
    </span>
    <craft-icon class="svg-icon text-size-11 icon-arrow shrink-0" name="arrows--arrow-head-down-sm"></craft-icon>
    <craft-icon
      *ngIf="!hideRemoveFilter"
      class="svg-icon icon-remove text-size-8"
      matTooltip="Remove filter"
      matTooltipPosition="above"
      (click)="removeFilter($event)"
      name="general--close-sm"
    ></craft-icon>
  </button>
</ng-container>

<craft-icon
  class="svg-icon icon-clear text-size-9"
  matTooltip="Clear filter"
  matTooltipPosition="above"
  (click)="clearAndApply()"
  name="general--close-sm"
></craft-icon>

<mat-menu #multiSelectMenu="matMenu" class="filter-select-menu">
  <ng-template matMenuContent="">
    <div class="menu-search mat-mdc-menu-item d-flex align-items-center shrink-0">
      <craft-icon class="svg-icon text-size-13 mr-10" name="search--search"></craft-icon>
      <input
        type="text"
        #searchInput
        (click)="$event.stopPropagation()"
        [placeholder]="searchPlaceholder"
        [formControl]="searchControl"
      />
    </div>

    <div class="menu-scroll">
      <div
        mat-menu-item=""
        class="item-checkbox"
        *ngFor="let item of filteredItems | async; trackBy: identify"
        (click)="selectItem(item, $event)"
        craftDisableFocus=""
      >
        <mat-checkbox [checked]="selectedSet.has(item[idFieldName])" class="checkbox-black small">
          {{ item[labelFieldName] }}
        </mat-checkbox>
      </div>
    </div>

    <div class="dropdown-footer">
      <button (click)="clearSelected($event)" type="button" class="btn">Clear</button>
    </div>
  </ng-template>
</mat-menu>
